import { render, staticRenderFns } from "./clients-carteira-administrada.vue?vue&type=template&id=421da818&"
import script from "./clients-carteira-administrada.vue?vue&type=script&lang=js&"
export * from "./clients-carteira-administrada.vue?vue&type=script&lang=js&"
import style0 from "./clients-carteira-administrada.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421da818')) {
      api.createRecord('421da818', component.options)
    } else {
      api.reload('421da818', component.options)
    }
    module.hot.accept("./clients-carteira-administrada.vue?vue&type=template&id=421da818&", function () {
      api.rerender('421da818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/modal/carteira-administrada/clients-carteira-administrada.vue"
export default component.exports